import React, { useContext, useEffect, useState } from "react";
import { SpoilerContext } from "./../ricos-context";
import { Decoration_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const TextSpoiler = ({ children, spoilerData }) => {
  const { spoilerManager } = useContext(SpoilerContext);
  const { id } = spoilerData || {};
  const [isSpoilerActive, setIsSpoilerActive] = useState(id ? spoilerManager.isActive(id) : true);
  useEffect(() => {
    if (id) {
      spoilerManager?.registerSpoiler(id, () => setIsSpoilerActive(false));
    }
  }, []);
  const toggleSpoiler = () => {
    const { id: id2 } = spoilerData || {};
    id2 ? spoilerManager?.toggleSpoiler(id2) : setIsSpoilerActive(!isSpoilerActive);
  };
  return isSpoilerActive ? /* @__PURE__ */ React.createElement(
    "span",
    {
      role: "button",
      tabIndex: 0,
      onKeyDown: toggleSpoiler,
      onClick: toggleSpoiler,
      style: { filter: "blur(0.25em)", cursor: "pointer" }
    },
    children
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
const decorator = (element, spoilerDecoration) => {
  const { spoilerData } = spoilerDecoration;
  return /* @__PURE__ */ React.createElement(TextSpoiler, { key: `spoiler-${element.key}`, spoilerData }, element);
};
const SpoilerDecorator = {
  rule: (node) => !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.SPOILER),
  decorate: ({ element, node }) => {
    const spoilerDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.SPOILER
    );
    return decorator(element, spoilerDecoration);
  }
};
var nodeViewDecorator_default = SpoilerDecorator;
export {
  nodeViewDecorator_default as default
};
//# sourceMappingURL=nodeViewDecorator.js.map
